module.exports = __webpack_public_path__ + "img/2.b75e61b3.png";